import React from "react";

const BookingReportBar = (props) => {
    const { bookingDetails } = props;

    return (
        <>
            <div className="book-bar padding-b20 padding-lr20 margin-b20" style={{color: '#535354', fontSize: '14px', backgroundColor: '#f7f7f7'}}>
                <div className="row">
                    <div className="col-sm-4"></div>
                    <div className="col-sm-4 text-center padding-r50 padding-t20">
                        <strong>{bookingDetails.fromDate} To {bookingDetails.toDate}</strong>
                        <br />
                        <strong>{bookingDetails.type}: {bookingDetails.total}</strong>
                        <br />
                    </div>
                </div>
            </div>
        </>
    );
};

export default BookingReportBar